import { actionGenerator, IReduxAction } from '../../../actionGenerator';

export const INPUT_AUCTION_BET = 'AUCTION :: INPUT_AUCTION_BET';

export type TInputAuctionBetAction = IReduxAction<typeof INPUT_AUCTION_BET, number>;

/**
 * inputAuctionBet vs changeAuctionBet:
 * inputAuctionBet - вызывается при каждом вводе символа в инпут "Ваша ставка"
 * changeAuctionBet - вызывается только тогда, когда пользователь закончил вводить ставку
 */
export const inputAuctionBet = actionGenerator<typeof INPUT_AUCTION_BET, number>(INPUT_AUCTION_BET);
